import { ContactLinkCategory } from '@/shared/model/contactLinkCategory.ts';
import ContactLinkCategoryModalDelete from '../modals/ContactLinkCategoryModalDelete/ContactLinkCategoryModalDelete.tsx';
import { openContactLinkCategoryModal, refreshContactLinkCategories } from '../../hooks/useInit.ts';
import { ModalSize, RowAction, TableColumn } from '@fs/uikit-react';
import {
  ContactLinkCategoryModal,
  ModalMode
} from "../modals/ContactLinkCategoryModal";

export const getTableColumns = (): TableColumn[] => {
  return [
    {
      key: 'name',
      title: 'Назва',
      width: '100%',
      sortable: true,
    },
  ];
};

export const getRowActions = (handleDeleteItem: (record: ContactLinkCategory) => void): RowAction[] => {
  return [
    {
      type: 'delete',
      onClick: (record: ContactLinkCategory) => {
        handleDeleteItem(record);
      }
    }
  ];
};

export const filteredItems = (items: ContactLinkCategory[], searchValue: string): ContactLinkCategory[] => {
  if (searchValue === '') {
    return items;
  }

  const searchLower = searchValue.toLowerCase();
  return items.filter(c => (
    c.name.toLowerCase().includes(searchLower)
  ));
};

export const handleCreateItem = () => {
  openContactLinkCategoryModal(
    ModalSize.SMALL,
    'Створити категорію',
    <ContactLinkCategoryModal mode={ModalMode.CREATE} onSuccess={refreshContactLinkCategories} />
  );
};

export const handleEditItem = (item: ContactLinkCategory) => {
  openContactLinkCategoryModal(
    ModalSize.SMALL,
    'Редагувати категорію',
    <ContactLinkCategoryModal mode={ModalMode.EDIT} item={item} onSuccess={refreshContactLinkCategories} />
  );
};

export const handleDeleteItem = (item: ContactLinkCategory) => {
  openContactLinkCategoryModal(
    ModalSize.SMALL,
    'Видалити категорію',
    <ContactLinkCategoryModalDelete item={item} onSuccess={refreshContactLinkCategories} />
  );
};
